import { getItem, setItem } from '@alltrails/core/utils/localStorage';
import type { AlgoliaResultType } from '@alltrails/types/Algolia';
import type { RecentAlgoliaHit } from '@alltrails/types/AlgoliaResults';

const storageKey = 'algolia-recent-searches';
const maxStored = 50;

const getStoredHits = () => getItem<RecentAlgoliaHit[]>(storageKey) ?? [];

export const getRecentAlgoliaHits = (types: 'all' | AlgoliaResultType[], maxCount?: number) => {
  const filteredRecentHits = getStoredHits().filter(hit => types === 'all' || types.includes(hit.type));
  return maxCount ? filteredRecentHits.slice(0, maxCount) : filteredRecentHits;
};

export const addRecentAlgoliaHit = (recentHit: RecentAlgoliaHit) => {
  const nextHits = [recentHit, ...getStoredHits().filter(hit => hit.objectID !== recentHit.objectID)];
  setItem(storageKey, nextHits.slice(0, maxStored));
};
